import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/base.module.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

function SparkleIcon({ color, className }) {
    return (
        <svg
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={classNames([styles.container, { [className]: className !== null }])}
        >
            <path
                d="M8.47455 0.752891C9.14455 4.94289 12.2646 8.28289 16.2846 9.17289C16.3746 9.19289 16.3746 9.32289 16.2846 9.34289C12.2646 10.2329 9.14455 13.5729 8.47455 17.7629C8.45455 17.8629 8.32455 17.8629 8.30455 17.7629C7.63455 13.5729 4.51455 10.2329 0.494551 9.35289C0.404551 9.33289 0.404551 9.20289 0.494551 9.18289C4.51455 8.29289 7.63455 4.95289 8.30455 0.762891C8.31455 0.662891 8.45455 0.662891 8.47455 0.762891L8.47455 0.752891Z"
                fill={color}
            />
        </svg>
    );
}

SparkleIcon.propTypes = propTypes;
SparkleIcon.defaultProps = defaultProps;

export default SparkleIcon;
